export default "__VITE_ASSET__BdlMTe5s__"